import styled from "@emotion/styled";
import { AppBox, colors, theme } from "@talkouttech/portal-shared";

export const StyledAppBox = styled(AppBox)<{ removeMargin?: boolean }>`
  margin-top: ${({ removeMargin }) => (removeMargin ? "none" : theme.spacing(2))};
  padding: ${theme.spacing(1.25)};
  align-items: center;
  background-color: ${colors.info};
`;
